import PropTypes from "prop-types";
import { useState, useEffect, useCallback } from "react";
import errorUtils from "utils/error-utils";
import DialogButtonDivStyled from "components/elements/DialogButtonDivStyled";
import DialogButtonStyled from "components/elements/DialogButtonStyled";
import FormStyled from "components/forms/FormStyled";
import FormStyledError from "components/forms/FormStyledError";
import { entryPointApi, accessPointApi } from "services/brm/access-service";
import { projectIdState } from "atoms/atoms-admin";
import { useRecoilValue } from "recoil";
import getReactSelectArray from "utils/react-select-array";
import { FORM_LABEL } from "constants/brm";
import SelectAll from "components/forms/SelectAllReactSelect";
import { DetailTableType } from "features/brm";
import getUniqueArray from "./helpers/GetUniqueArray";
// import customDetailStyle from "./styles/BrmReactSelectDetailsStyles";

const AddEntryPointForm = ({ setModalIsOpen, setRefresh, elementNameInUrl, selectedElement }) => {
  const [postError, setPostError] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const projectId = useRecoilValue(projectIdState);

  const filterExisting = useCallback(async () => {
    let existingRelations = [];
    switch (elementNameInUrl) {
      case DetailTableType.ACCESS_POINTS.key: {
        const data = await accessPointApi.getAccessPointEntrypoint(selectedElement.id);
        existingRelations = data;
        break;
      }
      default: {
        break;
      }
    }
    return existingRelations;
  }, [elementNameInUrl, selectedElement.id]);

  useEffect(() => {
    async function getData() {
      const existingRelations = await filterExisting();

      const res = await entryPointApi.findEntryPointWithHttpInfo(projectId);
      if (res?.data) {
        const uniqueArray = getUniqueArray(res.data, existingRelations);
        setOptions(getReactSelectArray(uniqueArray));
      }
    }
    if (projectId) {
      getData();
    }
  }, [projectId, filterExisting]);

  const handleSelectChange = (selectedItems) => {
    const items = selectedItems || [];
    setSelectedOptions(items);
  };

  function getPutRequest(selectedId) {
    switch (elementNameInUrl) {
      case DetailTableType.ACCESS_POINTS.key: {
        return accessPointApi.addAccessPointEntrypointWithHttpInfo(selectedElement.id, {
          body: selectedId,
        });
      }
      default: {
        break;
      }
    }
    return undefined;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (selectedOptions.length > 0) {
      try {
        selectedOptions.forEach(async (item) => {
          const res = await getPutRequest(item.value);
          if (res?.response) {
            errorUtils.checkErrorStatus(res.response.status, res.response.statusText);
          }
        });
      } catch (err) {
        console.error("Error occurred on put request: ", err);
      }
      setModalIsOpen(false);
      setRefresh(true);
    } else {
      setPostError("*Please fill out all fields in the form prior to submitting.");
    }
  }

  return (
    <div id="AddEntryPointForm">
      <form onSubmit={handleSubmit} action="" id="AddEntryPointForm_form">
        <FormStyled>
          <div className="form-style" id="AddEntryPointForm_formContent">
            <label>{FORM_LABEL.entryPoints}</label>
            <SelectAll
              // styles={customDetailStyle}
              isMulti
              options={options}
              defaultValue={selectedOptions}
              value={selectedOptions}
              onChange={handleSelectChange}
              allowSelectAll
              allOption={{
                label: "Select all",
                value: "*",
              }}
              elementId="AddEntryPointForm_entryPoint"
            />
          </div>
        </FormStyled>
        <FormStyledError>{postError}</FormStyledError>
        <DialogButtonDivStyled>
          <DialogButtonStyled onClick={() => setModalIsOpen(false)} id="AddEntryPointForm_cancelButton">
            Cancel
          </DialogButtonStyled>
          <DialogButtonStyled type="submit" id="AddEntryPointForm_addButton">
            Add
          </DialogButtonStyled>
        </DialogButtonDivStyled>
      </form>
    </div>
  );
};

AddEntryPointForm.propTypes = {
  elementNameInUrl: PropTypes.any,
  selectedElement: PropTypes.shape({
    id: PropTypes.any,
  }),
  setModalIsOpen: PropTypes.func,
  setRefresh: PropTypes.func,
};

export default AddEntryPointForm;
